import { render, staticRenderFns } from "./MiuVipPlanSave.vue?vue&type=template&id=0d2e524a&scoped=true"
import script from "./MiuVipPlanSave.vue?vue&type=script&lang=js"
export * from "./MiuVipPlanSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2e524a",
  null
  
)

export default component.exports